import React from "react";
import moment from "moment";
import {
	Avatar,
	Box,
	Button,
	Card,
	CardContent,
	CardHeader,
	Divider,
	Typography,
	Grid,
	Badge,
	IconButton,
	Dialog,
	DialogContent,
	DialogContentText,
	Grow,
} from "@mui/material";
import PersonalDetails from "./PersonalDetails";
import HealthInfo from "./Dialogs/HealthInfo";
import { useTranslation, Trans } from "react-i18next";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import PaymentMethods from "./Payments/PaymentMethods";
import ImageUploader from "./Dialogs/ImageUploader";
import Loader from "../../utils/Loader";
import Notifications from "../../components/AlertMessage/Notifications";
import CommunicationPreferences from "./Dialogs/ComPreferences";
import styles from "../../styles";
import Title from "./Dialogs/Title";
import Photo from '../../media/me.jpg'
const classes: any = {
	root: {
		mt: { xs: 9.5, md: 6.5 },
		width: { xs: "100%", md: "95%", lg: "80%", xl: "75%" },
		ml: "auto",
		mr: "auto",
		pl: { xs: 0, md: 7.5 },
		mb: { xs: 5, md: 1 },
	},
	avatar: {
		height: 200,
		width: 200,
	},

	editAvatar: {
		width: "auto",
		height: { xs: 300, md: 500 },
		justifyContent: "center",
	},
	avatarBadge: {
		height: 30,
		width: 30,
		border: `solid 2px secondary.main`,
		color: "white",
		backgroundColor: "secondary.main",
		borderRadius: 20,
	},
	paper: {
		position: "absolute",
		width: 300,
		backgroundColor: "#FAFAFA",
		border: "2px solid #000",
		boxShadow: "shadows[5]",
		padding: "spacing(0, 2, 3)",
	},
	buttonPadding: {
		margin: "0px",
	},
	cardHeader: {
		backgroundColor: "primary.main",
		width: "100%",
		color: "white",
		alignItems: "center",
	},
	box: {
		alignItems: "center",
		justifyContent: "center",
		display: "flex",
		flexDirection: "column",
	},
	linkStyle: {
		marginTop: 30,
		marginRight: 10,
		border: "1px grey solid",
		borderRadius: 5,
		paddingTop: 8,
		paddingBottom: 10,
		paddingLeft: "15%",
		paddingRight: "15%",
		textDecoration: "none",
		color: "primary.main",
	},
	modal: {
		display: "flex",
		position: "relative",
		alignItems: "center",
		justifyContent: "center",
		height: { xs: "95%", md: "100%" },
		paddingTop: { md: 70 },
		paddingBottom: { md: 20 },

		overflow: "scroll",
		"&:focus": {
			outline: "none",
		},
	},
	modalContainer: {
		display: "flex",
		position: "relative",
		alignItems: "center",
		justifyContent: "center",
		overflow: "scroll",
	},
	capitalize: {
		textTransform: "capitalize",
	},
};

export default function Profile(props: any) {
	const [open, setOpen] = React.useState("0");
	const [initialLoad, setInitialLoad] = React.useState<boolean>(false);
	const [error, setError] = React.useState<any>("");

	useTranslation();
	const handleOpen = (number: any) => {
		setOpen(number);
	};
	const handleClose = () => {
		setOpen("0");
	};


	let profileImageLoad = "https://www.clipartkey.com/mpngs/m/152-1520367_user-profile-default-image-png-clipart-png-download.png";

	return (
		<div>
			<Box sx={classes.root}>
				<Grid direction="row" container justifyContent="center">
					<Grid item xs={11} md={10}>
						<div style={{ marginBottom: 20, color: "#FF0000" }}>
							<Card raised={true}>
								<CardHeader
									sx={classes.cardHeader}
									title={<Trans>Profile</Trans>}
								></CardHeader>
								<CardContent>
									<Box
										sx={{
											display: { xs: "none", sm: "flex" },
										}}
									>
										<Grid
											container
											alignContent="center"
											justifyContent="center"
										>
											<Grid
												item
												sm={4}
												sx={{
													display: "flex",
													alignContent: "center",
													justifyContent: "center",
													pr: "2.5rem",
													pt: 0.5,
												}}
											>
												<Badge
													overlap="circular"
													anchorOrigin={{
														vertical: "bottom",
														horizontal: "right",
													}}
													badgeContent={
														<IconButton onClick={() => handleOpen("4")}>
															<EditOutlinedIcon sx={classes.avatarBadge} />
														</IconButton>
													}
												>
													{Photo ?
														<Avatar
															sx={{ height: 160, width: 160, ml: "2rem" }}
															src={Photo}
														/> : "loading"}
												</Badge>
											</Grid>
											<Grid item sm={4} sx={{ pl: "1.5rem", pt: 1 }}>
												<Typography

													color="white"
													gutterBottom
													variant="h5"
												>
													John Doe
												</Typography>

												<Typography color="secondary.main" variant="body1">
													<Trans>Member Since</Trans>:{" "} <br />
													<span style={{ color: "white" }}>12/2022</span>
												</Typography>


												<Typography
													color="secondary.main"
													variant="body1"
													gutterBottom
												>
													<Trans>Member ID</Trans>: <br />  <span style={{ color: "white" }}>#987465</span>
												</Typography>

												{/* 
												<Typography align="left">
													<Button
														sx={{
															p: 0.5,
															pl: 2,
															pr: 2,
															mt: 0.5,
														}}
														variant="outlined"
														onClick={() => handleOpen("6")}
													>
														Belt Rank
													</Button>
												</Typography> */}

											</Grid>
											<Grid item sm={4}>
												<Grid container rowSpacing={1} sx={{ mt: 3 }}>

													{/* <Grid item sm={12}>
														<Button
															fullWidth
															variant="outlined"
															onClick={() => handleOpen("1")}
														>
															<Trans>QUESTIONNAIRES</Trans>
														</Button>
													</Grid> */}
													{/* <Grid item sm={12}><Button
														sx={{
															p: 0.5,
															pl: 2,
															pr: 2,
															mt: 0.5,
														}}
														variant="outlined"
														onClick={() => handleOpen("6")}
													>
														Belt Rank
													</Button></Grid> */}
													<Grid item sm={12} sx={{ mt: 1 }}>
														<Button
															fullWidth
															variant="outlined"
															color="secondary"

															onClick={() => handleOpen("5")}
														>
															<Trans>NOTIFICATION SETTINGS</Trans>
														</Button>
													</Grid>
													<Grid item sm={12}>
														<Button
															fullWidth
															variant="outlined"
															color="secondary"

															onClick={() => handleOpen("3")}
														>
															<Trans>Health Information</Trans>
														</Button>
													</Grid>
													{/* <Grid item sm={12}>
														<Button
															fullWidth
															variant="outlined"
															onClick={() => handleOpen("2")}
														>
															<Trans>MANAGE USERS</Trans>
														</Button>
													</Grid> */}
												</Grid>
											</Grid>
										</Grid>
									</Box>
									<Box
										sx={{
											alignItems: "center",
											justifyContent: "center",
											display: { xs: "flex", sm: "none" },
											flexDirection: "column",

										}}
									>
										<Badge
											overlap="circular"
											anchorOrigin={{
												vertical: "bottom",
												horizontal: "right",
											}}
											badgeContent={
												<IconButton onClick={() => handleOpen("4")}>
													<EditOutlinedIcon sx={classes.avatarBadge} />
												</IconButton>
											}
										>
											<Avatar
												sx={{ height: 150, width: 150 }}
												src={Photo}
											/>
										</Badge>

										<Typography

											color="primary.contrastText"
											gutterBottom
											variant="h5"
										>
											John Doe
										</Typography>

										<Typography color="secondary.main" variant="body1">
											<Trans>Member Since</Trans>:{" "}
											<span style={{ color: "white" }}>12/2022</span>
										</Typography>


										<Typography
											color="secondary.main"
											variant="body1"
											gutterBottom
										>
											<Trans>Member ID</Trans>:  <span style={{ color: "white" }}>#987465</span>
										</Typography>


										{/* <Typography align="center">
											<Button
												sx={{
													p: 0.5,
													pl: 2,
													pr: 2,
													mt: 0.5,
												}}
												variant="outlined"
												onClick={() => handleOpen("6")}
											>
												Belt Rank
											</Button>
										</Typography> */}

									</Box>
									<Dialog
										open={open === "4"}
										onClose={handleClose}
										sx={styles.modal}
										maxWidth="xs"
										fullWidth
										aria-labelledby="Edit Profile Pic"
										aria-describedby="Update profile pic"
									>
										<Title title="Edit Profile Image" onClose={handleClose} />
										<DialogContent sx={{ p: 0 }}>
											<DialogContentText>
												<ImageUploader
													profileImage={Photo
													}


													uploadProfileImage={props.uploadProfileImage}
													handleClose={handleClose}
													getProfileInfo={props.getProfileInfo}
													userConfig={props.userConfig}
												/>
											</DialogContentText>
										</DialogContent>
									</Dialog>

								</CardContent>
								<Divider />
								<Box sx={{ p: 2, display: { xs: "block", sm: "none" } }}>
									<Grid container spacing={2}>
										<Grid item xs={12} md={6} lg={4}>
											<Button
												fullWidth
												color="secondary"
												variant="outlined"
												onClick={() => handleOpen("3")}
											>
												<Trans>Health Information</Trans>
											</Button>
										</Grid>

										{/* <Grid item xs={12} md={6} lg={4}>
											<Button
												fullWidth
												variant="outlined"
												onClick={() => handleOpen("2")}
											>
												<Trans>MANAGE USERS</Trans>
											</Button>
										</Grid> */}
										{/* <Dialog
											scroll="paper"
											open={open === "2"}
											onClose={handleClose}
											fullWidth
											maxWidth="sm"
											sx={styles.modal}
											aria-labelledby="Users"
											aria-describedby="Manage Users"
										>
											<ManageUsers onClose={handleClose} />
										</Dialog> */}

										{/* <Grid item xs={12} md={6} lg={4}>
											<Button
												fullWidth
												variant="outlined"
												onClick={() => handleOpen("1")}
											>
												<Trans>QUESTIONNAIRES</Trans>
											</Button>
										</Grid> */}

										<Grid item xs={12} md={6} lg={4}>
											<Button
												fullWidth
												color="secondary"
												variant="outlined"
												onClick={() => handleOpen("5")}
											>
												<Trans>NOTIFICATION SETTINGS</Trans>
											</Button>
										</Grid>
										<Dialog
											open={open === "5"}
											onClose={handleClose}
											sx={styles.modal}
										>
											<CommunicationPreferences
												onClose={handleClose}
											/>

										</Dialog>
										{/* <Dialog
											open={open === "1"}
											maxWidth="xs"
											sx={styles.modal}
											fullWidth
											onClose={handleClose}
											aria-labelledby="Questionnaires"
											aria-describedby="Questionnaires Info"
										>
											<ManageQuestionnaires

												onClose={handleClose}
											/>
										</Dialog> */}
									</Grid>
								</Box>

								<Dialog
									open={open === "3"}
									onClose={handleClose}
									sx={styles.modal}
									aria-labelledby="Health"
									aria-describedby="Health Info"
								>
									<HealthInfo

										onClose={handleClose}
									/>
								</Dialog>
							</Card>
						</div>
						<div>
							<PersonalDetails {...props} />
							{/* <ManageMemberships />
							<Invoices /> */}
							<Grow in={true} timeout={800}>
								<div style={{ marginTop: 20, marginBottom: 20 }}>
									<PaymentMethods {...props} />
								</div>
							</Grow>
						</div>
					</Grid>
				</Grid>
			</Box>
		</div >
	);
}
